module.exports = __webpack_public_path__ + "img/order_plate_black.eda520fe.svg";